import ReactHlsPlayer from 'react-hls-player';

import style from '../Intro.module.css';

function VideoPlayer(props) {
    // console.log(props)
    const cctvName = props.cctvName
    const cctvUrl = props.cctvUrl
    const procCctvUrl = props.procCctvUrl

    return (
        <div id={ style.cc_video_player } >
            <div id={ style.cc_vp_div }>
                <div id={ style.cc_vp_name }>{ cctvName }</div>
                <button id={ style.cc_btn_close } onClick={() => { procCctvUrl() }}>×</button>
                <ReactHlsPlayer src={ cctvUrl } autoPlay={ true } controls={ false } width="100%" height="Auto" />
            </div>
        </div>
    )
    
}

export default VideoPlayer;